'use strict';

import {Component, ChangeDetectionStrategy} from '@angular/core';

@Component({
    selector: 'general-header-title',
    template: require('./general-header-title.component.html'),
    styles: [require('./general-header-title.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GeneralHeaderTitleComponent { }